import type { Order } from '@/types/order';

// Le numéro de commande montré au client doit être celui qu'il retrouve
// partout ailleurs : « COMMANDE N° 165 » sur le ticket imprimé, « Commande n°
// #165 » dans l'e-mail de confirmation, « #165 » dans le tableau de bord du
// restaurant. C'est `daily_number`, alloué par sale_api à la création de la
// commande. Le repli sur l'uuid ne sert que les commandes antérieures à la
// numérotation quotidienne, et reprend le format des e-mails (8 premiers
// caractères en majuscules) pour rester comparable.
export function orderDisplayNumber(order: Pick<Order, 'orderId' | 'dailyNumber'>): string {
  if (order.dailyNumber != null) return String(order.dailyNumber);
  return order.orderId.slice(0, 8).toUpperCase();
}
